export interface GetSetValueProp<T> {
  value: T
  setValue: (newValue: T) => void
}

export type Theme = "normal" | "dark";

export const fonts = ["Inter", "Roboto", "Bebas Neue", "Solway", "Open Sans", "Source Sans Pro", "Lato", "Gupter", "Montserrat", "Baskervville", "Raleway", "Poppins", "Zhi Mang Xing"];
export type Font = (typeof fonts)[number];

const getMonthsInDays = (months: number) => Math.floor((365 / 12) * months);

export interface TimeOption {
  text: string
  value: number
}

export const timeOptions: TimeOption[] = [
  { text: RESX.DateTime.YMonth, value: getMonthsInDays(1) },
  { text: RESX.DateTime.XMonths.replace("{0}", "6"), value: getMonthsInDays(6) },
  { text: RESX.DateTime.YYear, value: getMonthsInDays(12) },
  { text: RESX.DateTime.XYears.replace("{0}", "2"), value: getMonthsInDays(12 * 2) },
  { text: RESX.DateTime.XYears.replace("{0}", "3"), value: getMonthsInDays(12 * 3) },
  { text: RESX.DateTime.XYears.replace("{0}", "4"), value: getMonthsInDays(12 * 4) },
  { text: RESX.DateTime.XYears.replace("{0}", "5"), value: getMonthsInDays(12 * 5) }
];

export type FilterByTypes = "AllArtists" | "MultipleArtists" | "Productions";

export interface WizardState {
  theme: Theme
  culture: server.dto.Culture
  font: Font
  perPage: number
  upcomingShowDays: number
  pastShowsDays: number
  displayPagination: boolean
  displayHeader: boolean
  filterBy: FilterByTypes
  artists: server.dto.ArtistSmall[]
  productions: server.dto.TourSmall[]
  includeCancelled: boolean
}